import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    inject,
    Input,
    OnDestroy,
    Output,
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { filter, fromEvent, map, Subscription } from 'rxjs';


@Component({
    selector: 'pcp-emm-iframe',
    templateUrl: './emm-iframe.component.html',
    styleUrls: ['./emm-iframe.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: []
})
export class EmmIframeComponent implements OnDestroy {
    sanitizedUrl: SafeResourceUrl;
    private messageFromIframeSubscription: Subscription | undefined;

    /**
     * Set the source URL as a raw, unescaped string.
     */
    @Input() set iframeSrc(srcUrl: string) {
        this.sanitizedUrl =
            this.sanitizer.bypassSecurityTrustResourceUrl(srcUrl);
    }

    @Output() messageFromIframe = new EventEmitter<string>();

    private readonly sanitizer = inject(DomSanitizer);

    onIframeLoaded(target: EventTarget | null) {
        this.messageFromIframeSubscription?.unsubscribe();
        if (target !== null && target instanceof HTMLIFrameElement) {
            const iframe = target as HTMLIFrameElement;
            this.messageFromIframeSubscription = createIframeStartVideoListener(
                iframe
            ).subscribe((message) => this.messageFromIframe.next(message));
        }
    }

    ngOnDestroy() {
        this.messageFromIframe.complete();
        this.messageFromIframeSubscription?.unsubscribe();
    }
}

const createIframeStartVideoListener = (iframe: HTMLIFrameElement) =>
    fromEvent(window, 'message').pipe(
        filter(
            (event) =>
                event instanceof MessageEvent &&
                event.source === iframe.contentWindow
        ),
        map((event) => event as MessageEvent),
        filter(
            (event) =>
                typeof event.data === 'string' && event.data.startsWith('PCP-')
        ),
        map((event) => event.data as string)
    );
